// extracted by mini-css-extract-plugin
module.exports = {"review":"_1iE7jBDRv9jY0ZUbRxy05m","scrollMessage":"_4Ei_10O-9zcraRCi3ZDs6","scrollToTopButton":"_2AACQcyjS1zuUMtMR_kAG3","container":"_2tp4cGgMKojM0LRaUmYFFj"};